import { ReactWrapperComponent, AngularReact, registerElement } from '@angular-react/core';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { EventEmitter, Directive, ViewChild, Input, Output, Component, ChangeDetectionStrategy, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TextField, MaskedTextField } from '@fluentui/react/lib/TextField';
import { __decorate } from 'tslib';
import { Styled } from '@angular-react/fabric/lib/utils';

// Copyright (c) Microsoft Corporation. All rights reserved.
class FabBaseTextFieldComponent extends ReactWrapperComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer, { setHostDisplay: true });
        this.onClick = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.onChange = new EventEmitter();
        this.onBeforeChange = new EventEmitter();
        this.onNotifyValidationResult = new EventEmitter();
        /* Non-React props, more native support for Angular */
        // support for two-way data binding for `@Input() checked`.
        this.valueChange = new EventEmitter();
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onBeforeChangeHandler = this.onBeforeChangeHandler.bind(this);
        this.onNotifyValidationResultHandler = this.onNotifyValidationResultHandler.bind(this);
    }
    ngOnInit() {
        this.onRenderLabel = this.createRenderPropHandler(this.renderLabel);
        this.onRenderDescription = this.createRenderPropHandler(this.renderDescription);
        this.onRenderPrefix = this.createRenderPropHandler(this.renderPrefix);
        this.onRenderSuffix = this.createRenderPropHandler(this.renderSuffix);
    }
    onClickHandler(ev) {
        this.onClick.emit(ev && ev.nativeEvent);
    }
    onFocusHandler(ev) {
        this.onFocus.emit(ev && ev.nativeEvent);
    }
    onBlurHandler(ev) {
        this.onBlur.emit(ev && ev.nativeEvent);
    }
    onChangeHandler(event, newValue) {
        this.onChange.emit({ event: event.nativeEvent, newValue });
        this.valueChange.emit(newValue);
    }
    onBeforeChangeHandler(newValue) {
        this.onBeforeChange.emit({ newValue });
    }
    onNotifyValidationResultHandler(errorMessage, value) {
        this.onNotifyValidationResult.emit({ errorMessage, value });
    }
}
/** @nocollapse */ FabBaseTextFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabBaseTextFieldComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ FabBaseTextFieldComponent.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.1", type: FabBaseTextFieldComponent, inputs: { required: "required", placeholder: "placeholder", type: "type", cols: "cols", colSpan: "colSpan", rows: "rows", rowSpan: "rowSpan", min: "min", max: "max", pattern: "pattern", htmlFor: ["for", "htmlFor"], componentRef: "componentRef", multiline: "multiline", resizable: "resizable", autoAdjustHeight: "autoAdjustHeight", underlined: "underlined", borderless: "borderless", label: "label", description: "description", prefix: "prefix", suffix: "suffix", iconProps: "iconProps", defaultValue: "defaultValue", value: "value", disabled: "disabled", readOnly: "readOnly", errorMessage: "errorMessage", deferredValidationTime: "deferredValidationTime", className: "className", inputClassName: "inputClassName", ariaLabel: "ariaLabel", validateOnFocusIn: "validateOnFocusIn", validateOnFocusOut: "validateOnFocusOut", validateOnLoad: "validateOnLoad", theme: "theme", styles: "styles", autoComplete: "autoComplete", getErrorMessage: "getErrorMessage", renderLabel: "renderLabel", renderDescription: "renderDescription", renderPrefix: "renderPrefix", renderSuffix: "renderSuffix", maxLength: "maxLength" }, outputs: { onClick: "onClick", onFocus: "onFocus", onBlur: "onBlur", onChange: "onChange", onBeforeChange: "onBeforeChange", onNotifyValidationResult: "onNotifyValidationResult", valueChange: "valueChange" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabBaseTextFieldComponent, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], required: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], type: [{
                type: Input
            }], cols: [{
                type: Input
            }], colSpan: [{
                type: Input
            }], rows: [{
                type: Input
            }], rowSpan: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], pattern: [{
                type: Input
            }], htmlFor: [{
                type: Input,
                args: ['for']
            }], componentRef: [{
                type: Input
            }], multiline: [{
                type: Input
            }], resizable: [{
                type: Input
            }], autoAdjustHeight: [{
                type: Input
            }], underlined: [{
                type: Input
            }], borderless: [{
                type: Input
            }], label: [{
                type: Input
            }], description: [{
                type: Input
            }], prefix: [{
                type: Input
            }], suffix: [{
                type: Input
            }], iconProps: [{
                type: Input
            }], defaultValue: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], deferredValidationTime: [{
                type: Input
            }], className: [{
                type: Input
            }], inputClassName: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], validateOnFocusIn: [{
                type: Input
            }], validateOnFocusOut: [{
                type: Input
            }], validateOnLoad: [{
                type: Input
            }], theme: [{
                type: Input
            }], styles: [{
                type: Input
            }], autoComplete: [{
                type: Input
            }], getErrorMessage: [{
                type: Input
            }], renderLabel: [{
                type: Input
            }], renderDescription: [{
                type: Input
            }], renderPrefix: [{
                type: Input
            }], renderSuffix: [{
                type: Input
            }], maxLength: [{
                type: Input
            }], onClick: [{
                type: Output
            }], onFocus: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], onChange: [{
                type: Output
            }], onBeforeChange: [{
                type: Output
            }], onNotifyValidationResult: [{
                type: Output
            }], valueChange: [{
                type: Output
            }] } });

let FabTextFieldComponent = class FabTextFieldComponent extends FabBaseTextFieldComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer);
    }
};
/** @nocollapse */ FabTextFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabTextFieldComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabTextFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabTextFieldComponent, selector: "fab-text-field", viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabTextField"], usesInheritance: true, ngImport: i0, template: `
    <TextField
      #reactNode
      [required]="required"
      [placeholder]="placeholder"
      [type]="type"
      [cols]="cols"
      [colSpan]="colSpan"
      [rows]="rows"
      [rowSpan]="rowSpan"
      [min]="min"
      [max]="max"
      [pattern]="pattern"
      [htmlFor]="htmlFor"
      [componentRef]="componentRef"
      [multiline]="multiline"
      [resizable]="resizable"
      [autoAdjustHeight]="autoAdjustHeight"
      [underlined]="underlined"
      [borderless]="borderless"
      [label]="label"
      [description]="description"
      [prefix]="prefix"
      [suffix]="suffix"
      [iconProps]="iconProps"
      [defaultValue]="defaultValue"
      [value]="value"
      [disabled]="disabled"
      [readOnly]="readOnly"
      [errorMessage]="errorMessage"
      [deferredValidationTime]="deferredValidationTime"
      [className]="className"
      [inputClassName]="inputClassName"
      [ariaLabel]="ariaLabel"
      [validateOnFocusIn]="validateOnFocusIn"
      [validateOnFocusOut]="validateOnFocusOut"
      [validateOnLoad]="validateOnLoad"
      [theme]="theme"
      [styles]="styles"
      [autoComplete]="autoComplete"
      [GetErrorMessage]="getErrorMessage"
      [RenderLabel]="renderLabel"
      [RenderDescription]="renderDescription"
      [RenderPrefix]="renderPrefix"
      [RenderSuffix]="renderSuffix"
      [Change]="onChangeHandler"
      [BeforeChange]="onBeforeChangeHandler"
      [maxLength]="maxLength"
      [NotifyValidationResult]="onNotifyValidationResultHandler"
      (onClick)="onClickHandler($event)"
      (onFocus)="onFocusHandler($event)"
      (onBlur)="onBlurHandler($event)"
    >
    </TextField>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabTextFieldComponent = __decorate([
    AngularReact(),
    Styled('FabTextFieldComponent')
], FabTextFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabTextFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-text-field',
                    exportAs: 'fabTextField',
                    template: `
    <TextField
      #reactNode
      [required]="required"
      [placeholder]="placeholder"
      [type]="type"
      [cols]="cols"
      [colSpan]="colSpan"
      [rows]="rows"
      [rowSpan]="rowSpan"
      [min]="min"
      [max]="max"
      [pattern]="pattern"
      [htmlFor]="htmlFor"
      [componentRef]="componentRef"
      [multiline]="multiline"
      [resizable]="resizable"
      [autoAdjustHeight]="autoAdjustHeight"
      [underlined]="underlined"
      [borderless]="borderless"
      [label]="label"
      [description]="description"
      [prefix]="prefix"
      [suffix]="suffix"
      [iconProps]="iconProps"
      [defaultValue]="defaultValue"
      [value]="value"
      [disabled]="disabled"
      [readOnly]="readOnly"
      [errorMessage]="errorMessage"
      [deferredValidationTime]="deferredValidationTime"
      [className]="className"
      [inputClassName]="inputClassName"
      [ariaLabel]="ariaLabel"
      [validateOnFocusIn]="validateOnFocusIn"
      [validateOnFocusOut]="validateOnFocusOut"
      [validateOnLoad]="validateOnLoad"
      [theme]="theme"
      [styles]="styles"
      [autoComplete]="autoComplete"
      [GetErrorMessage]="getErrorMessage"
      [RenderLabel]="renderLabel"
      [RenderDescription]="renderDescription"
      [RenderPrefix]="renderPrefix"
      [RenderSuffix]="renderSuffix"
      [Change]="onChangeHandler"
      [BeforeChange]="onBeforeChangeHandler"
      [maxLength]="maxLength"
      [NotifyValidationResult]="onNotifyValidationResultHandler"
      (onClick)="onClickHandler($event)"
      (onFocus)="onFocusHandler($event)"
      (onBlur)="onBlurHandler($event)"
    >
    </TextField>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }] } });

let FabMaskedTextFieldComponent = class FabMaskedTextFieldComponent extends FabBaseTextFieldComponent {
    constructor(elementRef, changeDetectorRef, renderer) {
        super(elementRef, changeDetectorRef, renderer);
    }
};
/** @nocollapse */ FabMaskedTextFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabMaskedTextFieldComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ FabMaskedTextFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.1", type: FabMaskedTextFieldComponent, selector: "fab-masked-text-field", inputs: { mask: "mask", maskChar: "maskChar", maskFormat: "maskFormat" }, viewQueries: [{ propertyName: "reactNodeRef", first: true, predicate: ["reactNode"], descendants: true, static: true }], exportAs: ["fabMaskedTextField"], usesInheritance: true, ngImport: i0, template: `
    <MaskedTextField
      #reactNode
      [required]="required"
      [placeholder]="placeholder"
      [type]="type"
      [cols]="cols"
      [colSpan]="colSpan"
      [rows]="rows"
      [rowSpan]="rowSpan"
      [min]="min"
      [max]="max"
      [pattern]="pattern"
      [htmlFor]="htmlFor"
      [componentRef]="componentRef"
      [multiline]="multiline"
      [resizable]="resizable"
      [autoAdjustHeight]="autoAdjustHeight"
      [underlined]="underlined"
      [borderless]="borderless"
      [label]="label"
      [description]="description"
      [prefix]="prefix"
      [suffix]="suffix"
      [iconProps]="iconProps"
      [defaultValue]="defaultValue"
      [value]="value"
      [disabled]="disabled"
      [readOnly]="readOnly"
      [errorMessage]="errorMessage"
      [deferredValidationTime]="deferredValidationTime"
      [className]="className"
      [inputClassName]="inputClassName"
      [ariaLabel]="ariaLabel"
      [validateOnFocusIn]="validateOnFocusIn"
      [validateOnFocusOut]="validateOnFocusOut"
      [validateOnLoad]="validateOnLoad"
      [theme]="theme"
      [styles]="styles"
      [autoComplete]="autoComplete"
      [mask]="mask"
      [maskChar]="maskChar"
      [maskFormat]="maskFormat"
      [GetErrorMessage]="getErrorMessage"
      [RenderLabel]="renderLabel"
      [RenderDescription]="renderDescription"
      [RenderPrefix]="renderPrefix"
      [RenderSuffix]="renderSuffix"
      [Change]="onChangeHandler"
      [BeforeChange]="onBeforeChangeHandler"
      [NotifyValidationResult]="onNotifyValidationResultHandler"
      (onClick)="onClickHandler($event)"
      (onFocus)="onFocusHandler($event)"
      (onBlur)="onBlurHandler($event)"
    >
    </MaskedTextField>
  `, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
FabMaskedTextFieldComponent = __decorate([
    AngularReact(),
    Styled('FabMaskedTextFieldComponent')
], FabMaskedTextFieldComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabMaskedTextFieldComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fab-masked-text-field',
                    exportAs: 'fabMaskedTextField',
                    template: `
    <MaskedTextField
      #reactNode
      [required]="required"
      [placeholder]="placeholder"
      [type]="type"
      [cols]="cols"
      [colSpan]="colSpan"
      [rows]="rows"
      [rowSpan]="rowSpan"
      [min]="min"
      [max]="max"
      [pattern]="pattern"
      [htmlFor]="htmlFor"
      [componentRef]="componentRef"
      [multiline]="multiline"
      [resizable]="resizable"
      [autoAdjustHeight]="autoAdjustHeight"
      [underlined]="underlined"
      [borderless]="borderless"
      [label]="label"
      [description]="description"
      [prefix]="prefix"
      [suffix]="suffix"
      [iconProps]="iconProps"
      [defaultValue]="defaultValue"
      [value]="value"
      [disabled]="disabled"
      [readOnly]="readOnly"
      [errorMessage]="errorMessage"
      [deferredValidationTime]="deferredValidationTime"
      [className]="className"
      [inputClassName]="inputClassName"
      [ariaLabel]="ariaLabel"
      [validateOnFocusIn]="validateOnFocusIn"
      [validateOnFocusOut]="validateOnFocusOut"
      [validateOnLoad]="validateOnLoad"
      [theme]="theme"
      [styles]="styles"
      [autoComplete]="autoComplete"
      [mask]="mask"
      [maskChar]="maskChar"
      [maskFormat]="maskFormat"
      [GetErrorMessage]="getErrorMessage"
      [RenderLabel]="renderLabel"
      [RenderDescription]="renderDescription"
      [RenderPrefix]="renderPrefix"
      [RenderSuffix]="renderSuffix"
      [Change]="onChangeHandler"
      [BeforeChange]="onBeforeChangeHandler"
      [NotifyValidationResult]="onNotifyValidationResultHandler"
      (onClick)="onClickHandler($event)"
      (onFocus)="onFocusHandler($event)"
      (onBlur)="onBlurHandler($event)"
    >
    </MaskedTextField>
  `,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i0.Renderer2 }]; }, propDecorators: { reactNodeRef: [{
                type: ViewChild,
                args: ['reactNode', { static: true }]
            }], mask: [{
                type: Input
            }], maskChar: [{
                type: Input
            }], maskFormat: [{
                type: Input
            }] } });

// Copyright (c) Microsoft Corporation. All rights reserved.
const components = [FabTextFieldComponent, FabMaskedTextFieldComponent];
class FabTextFieldModule {
    constructor() {
        // Add any React elements to the registry (used by the renderer).
        registerElement('TextField', () => TextField);
        registerElement('MaskedTextField', () => MaskedTextField);
    }
}
/** @nocollapse */ FabTextFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabTextFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ FabTextFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabTextFieldModule, declarations: [FabTextFieldComponent, FabMaskedTextFieldComponent], imports: [CommonModule], exports: [FabTextFieldComponent, FabMaskedTextFieldComponent] });
/** @nocollapse */ FabTextFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabTextFieldModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.1", ngImport: i0, type: FabTextFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: components,
                    exports: components,
                    schemas: [NO_ERRORS_SCHEMA],
                }]
        }], ctorParameters: function () { return []; } });

/**
 * Generated bundle index. Do not edit.
 */

export { FabMaskedTextFieldComponent, FabTextFieldComponent, FabTextFieldModule };
